import { captureMessage } from '@sentry/browser';

export const apiCatch = error => {
  captureMessage(`API Error | ${error}`);
};
